import axios from 'axios';
import { UNKNOW_ERROR, NO_INTERNET } from '../config/constants';

const API = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}`,
    withCredentials: true,
});

export default API;

export interface ApiResult {
    error?: string;
}

export interface ApiResponse {
    code: number;
    message: string;
}

export function getErrorMessage(error: any) {
    let message;
    if (!navigator.onLine) {
        message = NO_INTERNET;
    } else if (error?.response?.data?.message) {
        message = error.response.data.message;
    } else {
        message = UNKNOW_ERROR;
    }
    return message;
}

export function getDetailedErrorMessage(error: any) {
    let message;
    if (!navigator.onLine) {
        message = NO_INTERNET;
    } else if (error?.response?.data?.message) {
        message = error.response.data.message;
    } else if (error) {
        message = error;
    } else {
        message = UNKNOW_ERROR;
    }
    return message;
}

export interface AttachRequestInterceptorOptions {
    authToken: string;
}
